// TODO: Remove this module from `core-js@4` since it's split to modules listed below
require('../modules/es.promise.constructor');
require('../modules/es.promise.all');
require('../modules/es.promise.catch');
require('../modules/es.promise.race');
require('../modules/es.promise.reject');
require('../modules/es.promise.resolve');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.promise.js
// module id = 1110
// module chunks = 0